export default function isValidPercentage(value) {


    if (parseInt(value) < 10) {
        return false;
    }
    return true;
}